import { Model } from '@vuex-orm/core'
// Import profond, comme pour les referentiels de degustation :
// `requestSerializer` n'est pas reexporte par le wrapper de la toolbox, mais le
// paquet expedie bien `src/store/*`.
import requestSerializer from 'aveine-toolbox/src/store/adapter/serializer'
import QuizAnswer from './quiz-answer'

/**
 * Quizz du bloc « Le saviez-vous » de la Home (REDMINE-12962).
 *
 * Ce modele vit ici et non dans aveine-toolbox : le back-office est le seul
 * client qui edite ces quizz, l'application ne fait que les lire a travers
 * consumer-api.
 */
export default class Quiz extends Model {
  static entity = 'quizzes'

  static fields () {
    return {
      '$entity_name': this.attr(this.entity),
      'id': this.attr(null),
      // Traductions : des objets { fr, en, it, de, ko, zh, ja, es, nl }, pas
      // des chaines. `fr` et `en` sont exiges par CRUD-Wine.
      'theme': this.attr({}),
      'question': this.attr({}),
      // Facultative : le « pourquoi », affiche apres la reponse.
      'explanation': this.attr({}),
      'published': this.boolean(false),
      // Le jour ou le quiz sort, un par jour (REDMINE-13588). Horodatage a minuit.
      'day': this.attr(null),
      'answers': this.hasMany(QuizAnswer, 'quiz_id'),
      'created_at': this.string(),
      'updated_at': this.string(),
      'deleted': this.boolean(false)
    }
  }

  static readOnlyFields = []

  static apiConfig = {
    transformRequest: (data) => {
      if (data) {
        return requestSerializer(this.entity, data)
      } else {
        return null
      }
    }
  }
}
